import { getTransitHouseConsignmentFormFieldRequirement } from './transit/houseConsignment'
import { getTransitConsignmentItemFormFieldRequirement } from './transit/consignmentItem'
import { getTransitTransitOperationFieldRequirement } from './transit/transitOperation'
import { getEnsTransitOperationFieldRequirement } from './ens/transitOperation'
import { getEnsHouseConsignmentFormFieldRequirement } from './ens/houseConsignment'
import { getEnsConsignmentItemFormFieldRequirement } from './ens/consignmentItem'
import { NctsScope } from '../../../../../shared/ncts/types'
import { optional } from '../../../models/fieldRules'

function getDeclarationFieldRequirementsResolver(scope: NctsScope, isEns: boolean) {
  if (scope === 'transitOperation') {
    return isEns ? getEnsTransitOperationFieldRequirement : getTransitTransitOperationFieldRequirement
  }
  if (scope === 'houseConsignment') {
    return isEns ? getEnsHouseConsignmentFormFieldRequirement : getTransitHouseConsignmentFormFieldRequirement
  }
  if (scope === 'consignmentItem') {
    return isEns ? getEnsConsignmentItemFormFieldRequirement : getTransitConsignmentItemFormFieldRequirement
  }

  return optional
}

export default getDeclarationFieldRequirementsResolver
